import { render, staticRenderFns } from "./Decretos.vue?vue&type=template&id=7015d549&scoped=true"
import script from "./Decretos.vue?vue&type=script&lang=ts"
export * from "./Decretos.vue?vue&type=script&lang=ts"
import style0 from "./Decretos.vue?vue&type=style&index=0&id=7015d549&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7015d549",
  null
  
)

export default component.exports